// Module
var code = `<div class="form-entity-dialog h-100 d-flex flex-column">
	<div class="error mb-1 p-2 d-none">Error</div>
	<div class="info-message mb-1 p-2 text-success d-none">Success</div>
	<!-- Form -->
	<form class="form-entity form-material overflow-hidden h-100 d-flex flex-column" name="form-entity">
		<input type="hidden" name="id" />
		<input type="hidden" name="fromID" />
		<input type="hidden" name="toID" />
		<input type="hidden" name="meta[store]" />

		<div class="form-top">
			<!-- Description of the entity -->
			<div class="entity-description d-flex p-3 bg-secondary-subtle rounded">
				<!-- Filled with jQuery -->
			</div>
		</div>
		<div class="form-body overflow-auto flex-grow-1">
			<!-- Dynamic properties -->
			<div class="p-3">
				<fieldset class="labels mb-2">
					<div class="ps-1 fs-5">Labels</div>
					<input type="text" class="labels form-control" name="labels" autofocus="autofocus" placeholder="e.g. Label1, Label2"/>
				</fieldset>
				<fieldset class="type mb-2">
					<div class="ps-1 fs-5">Type</div>
					<input type="text" class="type form-control" name="type" placeholder="Type"/>
				</fieldset>
	
				<div class="tabs">
					<ul class="nav nav-tabs border-bottom-0">
						<li class="tab nav-item border border-bottom-0 rounded-top ms-1 me-2"><a class="nav-link" href="#entity-form-edit-tab">Edit</a></li>
						<li class="tab nav-item border border-bottom-0 rounded-top"><a class="nav-link" href="#entity-form-json-tab">JSON</a></li>
					</ul>
	
					<div id="entity-form-edit-tab" class="form-control">
						<div class="form-control mb-4">
							<fieldset class="dynamic-set entity-properties">
								<div class="dynamic-set-exclude ps-1 fs-5">Properties</div>
								<table cellspacing=0 cellpadding=0 class="entity-property-table w-100">
									<tr class="dummy key-value-set entity-property dynamic-set-element">
										<td class="property-name-area align-top">
											<input disabled type="text" class="property-name form-control" placeholder="name" name="properties[name][]" />
										</td>
										<td class="property-value-area align-top px-1 pb-1">
											<textarea disabled class="property-value text-flexible form-control" rows="1" placeholder="value" name="properties[value][]"></textarea>
										</td>
										<td class="property-action-area align-top">
											<button type="button" class="btn btn-danger dynamic-set-remove"><span class="fa fa-times property-remove"></span></button>
										</td>
									</tr>
								</table>
							</fieldset>
		
							<!-- Action buttons -->
							<div class="d-flex justify-content-end mt-2">
								<button type="button" class="d-inline-flex align-items-center btn btn-secondary add-property">
									<i class="fa fa-plus me-1"></i>Add property
								</button>
							</div>
						</div>

						<div class="form-control">
							<fieldset class="dynamic-set entity-files">
								<div class="dynamic-set-exclude ps-1 fs-5">Files</div>
								<table cellspacing=0 cellpadding=0 class="entity-property-table w-100">
									<tr class="dummy key-value-set entity-file dynamic-set-element">
										<td class="property-name-area align-top">
											<input disabled type="text" class="property-name form-control" placeholder="name" name="properties[name][]" />
										</td>
										<td class="property-value-area align-top px-1 pb-1">
											<textarea disabled class="property-value text-flexible form-control" rows="1" placeholder="value" name="properties[value][]"></textarea>
										</td>
										<td class="file-action-area align-top">
											<label for="file-upload" class="btn btn-success set-current-file"><i class="fa fa-search dynamic-set-select-file"></i></label>
											<button type="button" class="btn btn-danger dynamic-set-remove"><i class="fa fa-times property-remove"></i></button>
										</td>
									</tr>
								</table>
							</fieldset>
		
							<!-- Action buttons -->
							<div class="d-flex justify-content-end mt-2">
								<button type="button" class="d-inline-flex align-items-center btn btn-secondary add-file">
									<i class="fa fa-plus me-1"></i>Add property
								</button>
							</div>
						</div>
	
					</div>
					<div 	id="entity-form-json-tab"
							class="form-control"
					>
						<div class="" id="json-edit-container">
							<textarea name="json-properties"
							></textarea>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Action buttons -->
		<div class="form-footer d-flex p-3 justify-content-between">
			<div class="d-flex">
				<div class="form-warning d-flex align-items-center px-1 me-2 bg-warning-subtle form-control w-auto hidden">
					<i class="fa fa-exclamation-triangle me-1"></i> If you modify a core node, it will be included in the Graphileons count.
				</div>
				<button type="button" class="button-restore btn btn-light hidden" title="This is a modified Graphileon core node. Now it is counted as a Graphileon. This will restore the node to the initial configuration.">
					<i class="fas fa-history me-1"></i>Restore to default
				</button>
			</div>
			<div class="d-flex ms-2">
				<button type="button" class="button-cancel d-flex align-items-center btn btn-danger">
					<i class="fa fa-times me-1"></i>Cancel
				</button>
				<button type="submit" class="button-apply d-flex align-items-center btn mx-2" disabled>
					<i class="fa fa-check me-1"></i>Apply
				</button>
				<button type="submit" class="button-save d-flex align-items-center btn btn-success form-entity-submit">
					<i class="fa fa-edit me-1"></i>Save
				</button>
			</div>
		</div>

	</form>

	<form class="form-file-upload d-none" style="visibility:hidden">
		<input type="file" name="entity-file" class="file-upload"/>
	</form>
</div>
`;
// Exports
export default code;